import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StateMagmntService {
  readonly showLoader = signal(false);
  readonly showSkeleton = signal(false);

  showHideLoader(show: boolean): void {
    if (show && this.showSkeleton()) {
      return;
    }
    this.showLoader.set(show);
  }

  showHideSkeleton(show: boolean): void {
    this.showSkeleton.set(show);
    if (show) {
      this.showLoader.set(false);
    }
  }
}
